import type { Database } from '@xleddyl/types'

export const useClient = () => {
   return useSupabaseClient<Database>()
}
